export const selectEviteEvent = ({eviteEvent}) => eviteEvent;
export const selectEventTemplateName = (state) => selectEviteEvent(state).template_name || '';
export const selectEventType = (state) => selectEviteEvent(state).event_type || '';
export const selectIsFuneral = (state) => selectEventType(state) === 'funeral_memorial_service';
export const selectOptions = (state) => selectEviteEvent(state).options;
export const selectShowGifting = (state) => !!selectOptions(state)?.event_option_show_gifting;
export const selectIsPremium = (state) => !!selectEviteEvent(state).isPremium;
export const selectPledgelingData = (state) => selectEviteEvent(state).pledgeling_data;
export const selectPledgelingDataOrganization = (state) =>
  selectPledgelingData(state)?.Organization;
export const selectPledgelingDataCrowdfund = (state) => selectPledgelingData(state)?.Crowdfund;
export const selectCharityId = (state) => selectPledgelingDataOrganization(state)?.pledgeling_id;
export const selectCrowdFundPurpose = (state) =>
  selectPledgelingDataCrowdfund(state)?.pledgeling_purpose;
